import {selectTheme} from '../../../store/state/theme'
import {defaultSvgProps, SvgProps} from '../type/props'

export const EventIcon = (props?: SvgProps) => {
  const {color} = selectTheme()
  const {width, height, fill, style} = defaultSvgProps(props, {
    width: 16,
    height: 16,
    fill: color.textIcon.secondary,
    style: {
      flexShrink: 0,
    },
  })

  return (
    <svg width={width} height={height} style={style} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.23967 3.99935L8.50634 5.33268H11.9997V9.33268H9.75968L9.49301 7.99935H4.66634V3.99935H8.23967ZM9.33301 2.66602H3.33301V13.9993H4.66634V9.33268H8.39967L8.66634 10.666H13.333V3.99935H9.59967L9.33301 2.66602Z'
        fill={fill}
      />
    </svg>
  )
}
